import { ConfigProvider } from "antd";
import React, { FC, ReactNode } from "react";
import { ThemeProvider } from "styled-components";

import { useAppSelector } from "@/hooks/redux";
import {
    antdDarkTheme,
    antdLightTheme,
    darkTheme,
    GlobalStyle,
    lightTheme,
} from "@/theme";

interface AppProvidersProps {
    children: ReactNode;
}

export const AppProviders: FC<AppProvidersProps> = ({ children }) => {
    const { type } = useAppSelector((s) => s.theme);

    const antdTheme = type === "dark" ? antdDarkTheme : antdLightTheme;
    const theme = type === "dark" ? darkTheme : lightTheme;

    return (
        <ThemeProvider theme={theme}>
            <ConfigProvider theme={antdTheme}>
                <GlobalStyle />
                {children}
            </ConfigProvider>
        </ThemeProvider>
    );
};
